// extracted by mini-css-extract-plugin
module.exports = {"customMark":"sanitize_customMark__lVcw6","customMarkMobile":"sanitize_customMarkMobile__3GzLJ"};